<div class="page-shell justify-content-center h-100 w-100">
  @if (!isModalContext) {
  <div>
    <app-sidebar></app-sidebar>
  </div>
  }

    <div class="w-100 h-100">
      <div class="card-main">
        <div class="mb-3">
          @if (isModalContext) {
          <div class="modal-header">
            <div class="container-title-text">Logs</div>
            <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.close()"></button>
          </div>
          } @else {
          <app-title [titleRouter]="'Logs'"></app-title>
          }

        </div>
        @if (!isModalContext) {
        <div class="mb-3">
          <form class="row align-items-center" [formGroup]="form">
            <div class="col-lg-3">
              <efx-date-range-picker label="Rango de movimientos" class="w-100" controlName="datepicker"
                [maxDate]="maxDate" startDatePlaceholder="Fecha inicial" endDatePlaceholder="Fecha final"
                [isDisabled]="false" [isRequired]="true" [weekendDisabled]="false" [formGroup]="form" id="datepicker"
                [validationOptions]="{ required: { message: 'Este campo es requerido.' } }">
              </efx-date-range-picker>
              @if (form.get('datepicker')?.invalid && form.get('datepicker')?.touched) {
              <div class="text-danger">
                Rango de fechas es requerido.
              </div>
              }
            </div>
            <!-- <div class="col-lg-4">
          <efx-text-field class="w-100 mb-0" label="Fuente" placeholder="" controlId="source"
            controlName="source" [formGroup]="form" name="source" id="source">
          </efx-text-field>
        </div> -->
            <div class="col-lg-3">
              @if (dataSource) {
              <efx-text-field class="w-100 mb-0" label="N° de Documento" placeholder="Ingresar un documento"
                controlId="numberdocuments" controlName="numberdocuments" [formGroup]="form" name="numberdocuments"
                id="numberdocuments">
              </efx-text-field>
              }
            </div>
            <div class="col-lg-3">
              <efx-text-field class="w-100 mb-0" label="Usuario" placeholder="Ingresar el usuario" controlId="user"
                controlName="user" [formGroup]="form" name="user" id="user">
              </efx-text-field>
            </div>
            <div class="col-lg-3">
              <efx-text-field class="w-100 mb-0" label="Origen" placeholder="Ingresar el origen" controlId="origen"
                controlName="origen" [formGroup]="form" name="origen" id="origen" [isRequired]="false">
              </efx-text-field>
            </div>
          </form>
        </div>
        <div class="d-flex align-items-center justify-content-between pb-3 mb-3 border-bottom-1"
          [hidden]="isModalContext">
          <div>@if (dateStartUI !== '' && dateEndUI !== '') {
            <span>Has seleccionado los siguientes criterios:
              <strong>{{dateStartUI}}</strong> hasta <strong>{{dateEndUI}}</strong></span>
            }
          </div>
          <div>
            <button class="efx-button-primary" [disabled]="!form.valid" (click)="onSetFilter()">
              <span class="material-symbols-outlined me-2">
                search
              </span>
              Buscar
            </button>
          </div>
        </div>
        }

        @if (initData) {
        <div class="d-flex align-items-center justify-content-between mb-3">
          <div class="container-page-size-selector">
            <!-- <efx-page-size-selector [dataSource]="dataSource" [validSizes]="[5, 10, 25, 50]">
        </efx-page-size-selector> -->
          </div>
          <div class="d-flex align-items-center">
            <button class="efx-button-secondary me-3" (click)="onCloseAllExpanded()">Ocultar todos</button>
            <button class="efx-button-primary" (click)="downloadAllLogs(currentBodyForRequest)"
              [disabled]="!data || data.length === 0">
              <span class="material-symbols-outlined me-2">
                download
              </span>
              Descargar CSV
            </button>
          </div>
        </div>
        @if (dataSource) {
        <div class="w-100">
          <div class="mb-3">
            <efx-data-table [dataSource]="dataSource" [pageSize]="pageSize" [hasNestedRows]="true"
              identityFieldName="requestId">
              @for (column of columns; track column) {
              <efx-grid-column [field]="column.field" [header]="column.header" [isVisible]="true"
                [isSortable]="column.isSortable">
              </efx-grid-column>
              }
              <efx-grid-column field="" header="" width="20" [isVisible]="true">
                <ng-template let-row="row" let-col let-rowIndex="rowIndex">
                  <div class="d-flex">
                    @if (row['operation'] !== 'CREATE') {
                    <span class="text-collapse-primary">
                      {{row.isNestedRowExpanded ? 'Ocultar':'Mostrar'}}
                    </span>
                    }
                    @if (row['operation'] !== 'CREATE') {
                    <efx-grid-row-expand-button [row]="row" [rowIndex]="rowIndex"
                      (onToggleRowExpand)="onRowExpanded($event)"></efx-grid-row-expand-button>
                    }
                  </div>
                </ng-template>
              </efx-grid-column>
              <efx-nested-row>
                <ng-template let-row="data">
                  <div class="w-100 bg-gray p-3">
                    <div class="log-detail-container">
                      <button class="log-copy-btn" (click)="copyRawJson(row.logDetailRaw)"
                        title="Copiar JSON crudo al portapapeles">
                        <span class="material-symbols-outlined log-copy-icon">content_copy</span>
                        Copiar Todo
                      </button>
                      <div class="log-detail-pre mb-0" [innerHTML]="row.logDetail"></div>
                    </div>
                  </div>
                </ng-template>
              </efx-nested-row>
            </efx-data-table>
          </div>
          <div class="d-flex justify-content-between">
            <div>
              <select class="efx-select" (change)="chagenPageSize($event)">
                @for (size of pagesSize; track size) {
                <option [value]="size">
                  {{size}}
                </option>
                }
              </select>
            </div>
            <div>
              <efx-pager [dataSource]="dataSource" [pageSize]="pageSize" [maxPagingButtons]="5"
                [showPagerSummary]="false" [showFirstLastButtons]="false">
              </efx-pager>
            </div>
          </div>
        </div>
        }
        } @else {
        <div class="w-100 d-flex justify-content-center container-emty-logs mt-4">
          <div class="container-info">
            <div class="icon text-center">
              <span class="material-symbols-outlined">
                info
              </span>
            </div>
            <div class="title">
              No hay visualización de logs
            </div>
          </div>
        </div>
        }


      </div>
    </div>
</div>

